import { AccountManagerSessionStorage } from "./Account-Manager/sessionStorage";
import { WalletSessionStorage } from "./Wallet/sessionStorage";
import { servers } from "./server";

export const services = {
  wallet: {
    sessionStorage: WalletSessionStorage,
  },
  accountManager: {
    sessionStorage: AccountManagerSessionStorage,
  },
  // token: {
  //   server: servers.token,
  // },
  // tokenKits: {
  //   server: servers.tokenKits,
  // },
  // currency: {
  //   server: servers.currency,
  // },
};
